import location from "../img/loc.png";
import phone from "../img/phone.png";
import gmail from "../img/gmail.png";

function Ubicacion() {
  return (
    <div className="container-xxl py-5" id="ubicacion">
      <div className="container">
        <div
          className="text-center mx-auto mb-5 wow fadeInUp"
          data-wow-delay="0.1s"
          style={{ maxWidth: "600px" }}
        >
          <h1 className="mb-3">Donde estamos</h1>
          <p>
            La localidad de Villa Icho Cruz se ubica a una hora de la ciudad de
            Córdoba. A su vez, la cabaña se encuentra a pocas cuadras del centro
            y a 50 metros del rio San Antonio, balneario Cuesta Blanca.
          </p>
        </div>
        <div className="row g-4">
          <div className="col wow fadeInUp" data-wow-delay="0.1s">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d13610.72050386431!2d-64.5737167!3d-31.4779843!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x942d69002a86322b%3A0xeb866e76962de5bb!2sChamp%20Elvin%20-%20Caba%C3%B1a!5e0!3m2!1ses-419!2sar!4v1730157453882!5m2!1ses-419!2sar"
              className="position-relative rounded w-100 h-100"
              style={{ minHeight: "400px", border: 0 }}
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
              aria-hidden="false"
              tabIndex="0"
            ></iframe>
          </div>
          <div className="col-12">
            <div className="row gy-4">
              <div
                className="col-md-6 col-lg-4 wow fadeIn"
                data-wow-delay="0.1s"
              >
                <div className="bg-light rounded p-3">
                  <div
                    className="d-flex align-items-center bg-white rounded p-3"
                    style={{ border: "1px dashed rgba(0, 185, 142, .3)" }}
                  >
                    <div
                      className="icon me-3"
                      style={{ width: "45px", height: "45px" }}
                    >
                      <img className="myicons" src={location} alt="Ícono"></img>
                    </div>
                    <a
                      href="https://maps.app.goo.gl/EAvLj8FfiY4ZU7T16"
                      target="_blank"
                    >
                      <span>Ibicuy 218, Villa Icho Cruz</span>
                    </a>
                  </div>
                </div>
              </div>
              <div
                className="col-md-6 col-lg-4 wow fadeIn"
                data-wow-delay="0.3s"
              >
                <div className="bg-light rounded p-3">
                  <div
                    className="d-flex align-items-center bg-white rounded p-3"
                    style={{ border: "1px dashed rgba(0, 185, 142, .3)" }}
                  >
                    <div
                      className="icon me-3"
                      style={{ width: "45px", height: "45px" }}
                    >
                      <img className="myicons" src={gmail} alt="Ícono"></img>
                    </div>
                    <a href="mailto:colomeyer2@gmail.com" target="_blank">
                      <span>colomeyer2@gmail.com</span>
                    </a>
                  </div>
                </div>
              </div>
              <div
                className="col-md-6 col-lg-4 wow fadeIn"
                data-wow-delay="0.5s"
              >
                <div className="bg-light rounded p-3">
                  <div
                    className="d-flex align-items-center bg-white rounded p-3"
                    style={{ border: "1px dashed rgba(0, 185, 142, .3)" }}
                  >
                    <div
                      className="icon me-3"
                      style={{ width: "45px", height: "45px" }}
                    >
                      <img className="myicons" src={phone} alt="Ícono"></img>
                    </div>
                    <a href="https://wa.me/543516073558" target="_blank">
                      <span>+54 351 607 3558</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Ubicacion;
